<div class="container" style="overflow:hidden;margin-left:0.5em;">
 
  <router-outlet></router-outlet>
</div>